const IDP_URL = import.meta.env.VITE_APP_ENV === 'development' ? import.meta.env.VITE_IDP_BASE_URL_DEV : import.meta.env.VITE_IDP_BASE_URL
const TOKEN_QUERY_PARAM = 'token'
const AUTH_COOKIE_NAME = 'session'

export const useIdpAuth = () => {
  const consumeTokenFromQuery = (saveToCookie = false) => {
    const url = new URL(window.location.href)
    const token = url.searchParams.get(TOKEN_QUERY_PARAM)

    if (!token) return false

    if (saveToCookie) {
      const isSecure = window.location.href === 'https:'
      const maxAge = 60 * 60 * 24 * 30

      document.cookie = `${AUTH_COOKIE_NAME}=${token}; path=/; max-age=${maxAge}; samesite=${isSecure ? 'none' : 'lax'}${isSecure ? '; secure' : ''}`
    }

    url.searchParams.delete(TOKEN_QUERY_PARAM)
    window.history.replaceState({}, '', url.pathname + url.search + url.hash)

    return true
  }

  const buildRedirectUrl = (mode, currentUrl) => {
    const redirectUri = currentUrl ?? window.location.href
    const target = new URL(IDP_URL)

    if (mode === 'logout') {
      target.pathname = target.pathname.replace(/\/$/, '') + '/logout'
    }

    target.searchParams.set('redirect_uri', redirectUri)

    return target.toString()
  }

  const redirectToIdp = (mode, currentUrl) => {
    window.location.href = buildRedirectUrl(mode, currentUrl)
  }

  return {
    consumeTokenFromQuery,
    buildRedirectUrl,
    redirectToIdp
  }
}
